import { render, staticRenderFns } from "./SeparatorMenu.vue?vue&type=template&id=268d47fc&"
import script from "./SeparatorMenu.vue?vue&type=script&lang=js&"
export * from "./SeparatorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports